var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPairSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.4,
    height: 17.55,
    viewBox: "0 0 21.4 17.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tuser-pair-search\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-pair-search"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.2,21.1a5.6,5.6,0,1,1,5.6-5.6A5.59,5.59,0,0,1,17.2,21.1Zm0-10.3a4.8,4.8,0,0,0-4.8,4.8,4.8,4.8,0,1,0,4.8-4.8Z",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,21.7l1.1-1.1a.42.42,0,0,0-.6-.6l-1.1,1.1a.37.37,0,0,0,0,.6.5.5,0,0,0,.6,0Z",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.6,8a3.31,3.31,0,0,1,3.2-3.3,3.31,3.31,0,0,1,3.3,3.2A3.25,3.25,0,1,1,7.6,8Zm.8,0a2.29,2.29,0,0,0,2.4,2.3,2.29,2.29,0,0,0,2.3-2.4,2.29,2.29,0,0,0-2.4-2.3A2.35,2.35,0,0,0,8.4,8Z",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7,16.4C5.7,14,8,12,10.9,12a9.85,9.85,0,0,1,1.7.2c.2.1.4.3.3.5s-.3.4-.5.3a6.75,6.75,0,0,0-1.4-.2c-2.4,0-4.4,1.6-4.3,3.6a.43.43,0,0,1-.4.4C5.9,16.8,5.7,16.6,5.7,16.4Z",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,10a2.35,2.35,0,1,1,2.4,2.3A2.49,2.49,0,0,1,3.2,10Zm.6-.1a1.71,1.71,0,0,0,1.8,1.7,1.75,1.75,0,0,0-.1-3.5A1.92,1.92,0,0,0,3.8,9.9Z",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9,16.3c0-1.7,1.7-3.2,3.8-3.2a4.87,4.87,0,0,1,1.2.1c.2,0,.3.2.2.4s-.2.3-.4.2a3.4,3.4,0,0,0-1-.1,3,3,0,0,0-3.2,2.6.27.27,0,0,1-.3.3A.32.32,0,0,1,1.9,16.3Z",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.6 -4.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.6 -4.5)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPairSearch2);
export default __webpack_public_path__ + "static/media/user-pair-search2.32dc4749235f53f654704459b0f1249b.svg";
export { ForwardRef as ReactComponent };